export enum CONTRACT_TYPE{
  CASH = "cash",
  LOAN = "loan",
  LEASE= "lease"
}